import React, { useEffect, useCallback } from 'react';
import { initIntercom } from '../utils/services';
import { isUserApplicant } from '../utils/userHelpers';

const IntercomProvider = ({ children }) => {
  const initializeIntercom = useCallback(() => {
    // Only initialize Intercom for applicant users
    if (isUserApplicant()) {
      initIntercom();
    }
  }, []);

  useEffect(() => {
    // Initialize Intercom when component mounts
    initializeIntercom();
    
    // Listen for storage changes to re-initialize when user logs in
    const handleStorageChange = (e) => {
      if (e.key === 'userInfo') {
        initializeIntercom();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for custom events when userInfo changes in the same tab
    const handleUserInfoChange = () => {
      initializeIntercom();
    };
    
    window.addEventListener('userInfoUpdated', handleUserInfoChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userInfoUpdated', handleUserInfoChange);
    };
  }, [initializeIntercom]);

  return <>{children}</>;
};

export default IntercomProvider;